import withForm from './withForm';

// A convenience wrapper around the button to submit the from. The onSubmit
// prop is called with the button is clicked and the form is valid.
export const createSubmitButton = withForm(
  undefined,
  formActions => ({ submitForm: formActions.submitForm }),
  (_, formActions, props) => {
    const { onSubmit, validateBeforeSubmit } = props;
    return {
      ...props,
      // The errors from submit are swallowed to prevent an unhandled promise reject. Note that using
      // this button means any errors retuned will be ignored.
      onClick: () => formActions.submitForm(onSubmit, { validateBeforeSubmit }).catch(__ => undefined)
    };
  });

// A Submit button that just wraps the default button element.
export default createSubmitButton('button');
